var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.75C21.4142 12.75 21.75 12.4142 21.75 12C21.75 11.5858 21.4142 11.25 21 11.25L21 12L21 12.75ZM2.46967 11.4697C2.17678 11.7626 2.17678 12.2374 2.46967 12.5303L7.24264 17.3033C7.53553 17.5962 8.01041 17.5962 8.3033 17.3033C8.59619 17.0104 8.59619 16.5355 8.3033 16.2426L4.06066 12L8.3033 7.75736C8.5962 7.46446 8.5962 6.98959 8.3033 6.6967C8.01041 6.4038 7.53553 6.4038 7.24264 6.6967L2.46967 11.4697ZM21 12L21 11.25L3 11.25L3 12L3 12.75L21 12.75L21 12Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.f69ca1cadaf1045792b1b58eb7ed72d3.svg";
export { ForwardRef as ReactComponent };